import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import { Navbar } from "./components/navbar";

// Lazy load components for better performance
const Home = React.lazy(() =>
  import("./pages/home-new").then((module) => ({ default: module.Home })),
);
const About = React.lazy(() => import("./pages/about"));
const Events = React.lazy(() => import("./pages/events"));
const AnnualReport = React.lazy(() => import("./pages/annual"));
const SignUp = React.lazy(() => import("./pages/signup"));

// Loading component
const PageLoader = () => (
  <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center">
    <div className="text-center">
      <div className="relative">
        <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-8 h-8 bg-blue-600 rounded-full animate-pulse"></div>
        </div>
      </div>
      <p className="mt-4 text-gray-600 font-medium">Loading...</p>
    </div>
  </div>
);

function AppRoutes() {
  return (
    <Router>
      <Navbar />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/events" element={<Events />} />
          <Route path="/annual" element={<AnnualReport />} />
          <Route path="/sign-up" element={<SignUp />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default AppRoutes;
